import { timeout } from 'donot';
import Vue from 'vue';
import Vuex from 'vuex';
import STOPWORDS from './stopwords.js';
import { createStore } from './store.js';
import WkPercbar from './components/wk-percbar.vue';

const MAX_SUGGESTIONS = 5;
const DIFFICULTY_TRESHOLD = 90;

export function createView(WORDS) {
    Vue.use(Vuex);

    const store = createStore();

    // Seems putting data in a reactive getter locks up Safari
    function getWord(word) {
        word = word.trim().toLowerCase();

        if (STOPWORDS.includes(word)) {
            return null;
        } else if (word in WORDS) {
            return {
                href : `#${word}`,
                label : word,
                link : `https://nl.wiktionary.org/wiki/${word}`,
                perc_be : WORDS[word][0],
                perc_nl : WORDS[word][1]
            };
        } else {
            return null;
        }
    }

    return new Vue({
        store,

        el : "#main",

        components : { WkPercbar },

        computed : {
            selection() {
                return this.selectionQuery ? getWord(this.selectionQuery) : null;
            }
        },

        data() {
            return {
                difficultTreshold : DIFFICULTY_TRESHOLD,
                difficultWords : [],
                mode : 'word',
                query : null,
                selectionQuery : null,
                suggestions : [],
                text : '',
                textAnalyzed : ''
            }
        },

        methods : {
            analyseText() {
                let words = this.text.split(/[, ]+/);

                words = words.map((word) => {
                    const wordData = getWord(word);

                    if (wordData) {
                        if (wordData.perc_nl < DIFFICULTY_TRESHOLD ||
                            wordData.perc_be < DIFFICULTY_TRESHOLD) {
                            // Check if word is in difficultwords
                            const hasDifficultWord = this.difficultWords.find((w) => {
                                return w.label === wordData.label;
                            });

                            if (!hasDifficultWord) {
                                this.difficultWords.push(wordData);
                            }

                            return `<mark><a href="${wordData.href}">${word}</a></mark>`;
                        } else {
                            return word;
                        }
                    } else {
                        return word;
                    }
                });

                // And filter difficultWords on the Dutch percentages
                this.difficultWords = this.difficultWords.sort((a, b) => {
                    return a.perc_nl < b.perc_nl ? -1 : 1;
                });

                this.textAnalyzed = words.join(' ');

                // Obviously an awful hack
                window.location.hash = 'text-analyzed';
            },

            async goHash() {
                this.mode = 'word';

                const hash = window.location.hash.slice(1);

                // FIXME, especially the reset stuff is ugly
                if (!hash) {
                    this.selectionQuery = null;
                    await timeout(100);
                    this.$refs.query.focus();
                    return;
                } else if (hash === 'text-analyzed') {
                    this.mode = 'text';
                    return;
                } else if (hash === 'text') {
                    this.mode = 'text';
                    this.difficultWords = [];
                    this.text = '';
                    this.textAnalyzed = '';
                    return;
                } else if (!!hash) {
                    this.query = null;
                    this.suggestions = [];
                    this.selectionQuery = hash;
                }
            },

            getWord(word) {
                const wordData = getWord(word);

                if (wordData) {
                    return wordData;
                } else {
                    // Make sure we don't get stuck in a weird state
                    window.location.hash = '';
                    return null;
                }
            }
        },

        mounted() {
            window.addEventListener('hashchange', this.goHash.bind(this));
            this.goHash();
            this.$refs.query.focus();
        },

        watch : {
            query() {
                this.suggestions = [];

                let count = 0;

                if (!this.query || this.query === '') {
                    return;
                }

                // On iOS input field are capitalized by default, we've
                // already added autocomplete=off there
                let query = this.query.trim().toLowerCase();

                for (const key in WORDS) {
                    if (key.startsWith(query)) {
                        this.suggestions.push(getWord(key));
                        count += 1;
                    }

                    if (count === MAX_SUGGESTIONS) {
                        break;
                    }
                }
            }
        }
    });
}